    import React, { useState } from "react";

    import Navbar from "../components/Navbar/Navbar";
    import Hero from "../components/Hero/Hero";
    import Services from "../components/Services/Services";
    import Projects from "../components/Projects/Projects";
    import UpProjects from "../components/UpcomingProjects";

    import About from "../components/About/About";
    import Contact from "../components/Contact/Contact";
    import Footer from "../components/Footer/Footer";
    import EnquiryButton from "../components/EnquiryButton/EnquiryButton";
    import EnquiryModal from "../components/EnquiryModal/EnquiryModal";
    import WhatsAppButton from "../components/WhatsAppButton/WhatsAppButton";
    import Career from "../components/Career"
    import { Helmet } from "react-helmet-async";

  const Home = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Helmet>
        <title>
          Jayaram Group | Premium Real Estate Developers in Bangalore
        </title>

        <meta
          name="description"
          content="Jayaram Group is a trusted real estate developer in Bangalore offering premium residential and commercial projects. Explore luxury apartments and villas."
        />

        <meta
          name="keywords"
          content="Jayaram Group, real estate Bangalore, apartments in Bangalore, luxury flats Bangalore"
        />

        <meta
          property="og:title"
          content="Jayaram Group | Real Estate Developers Bangalore"
        />

        <meta
          property="og:description"
          content="Discover premium residential and commercial properties by Jayaram Group in Bangalore."
        />

        <meta
          property="og:image"
          content="https://www.jayaramgroup.com/logo.png"
        />

        <meta property="og:type" content="website" />

        <link
          rel="canonical"
          href="https://www.jayaramgroup.com/"
        />
      </Helmet>

      <Navbar />

      <Hero onEnquire={() => setShowModal(true)} />
      <Services />
      <About />

      <div id="projects">
        <Projects limit={15} />
      </div>

      <div id="upprojects">
        <UpProjects limit={11} />
      </div>

      
      <Contact />
     
        <Career />
    
      <Footer />


      <EnquiryButton onClick={() => setShowModal(true)} />
      <EnquiryModal
        open={showModal}
        onClose={() => setShowModal(false)}
      />
      <WhatsAppButton />
    </>
  );
};

    export default Home;
